const PROJECT_BY_ENVIRONMENT = Object.freeze({
  preview: 'affinityai-mvp-preview',
  production: 'affinityai-mvp',
});

const CONFIG_KEYS = Object.freeze([
  'FIREBASE_API_KEY',
  'FIREBASE_AUTH_DOMAIN',
  'FIREBASE_PROJECT_ID',
  'FIREBASE_STORAGE_BUCKET',
  'FIREBASE_MESSAGING_SENDER_ID',
  'FIREBASE_APP_ID',
]);

function readEnv(env, key) {
  return String(env[`REACT_APP_${key}`] ?? env[key] ?? '').trim();
}

function invalidConfig() {
  return new Error('firebase_client_configuration_invalid');
}

export function resolveFirebaseEnvironmentConfig(env = {}) {
  const nodeEnv = String(env.NODE_ENV || '').trim().toLowerCase();
  if (nodeEnv === 'test') {
    return {
      apiKey: 'synthetic-test-key',
      authDomain: 'demo-affinityai.firebaseapp.com',
      projectId: 'demo-affinityai',
      storageBucket: 'demo-affinityai.firebasestorage.app',
      messagingSenderId: '000000000000',
      appId: '1:000000000000:web:synthetic',
    };
  }

  const runtimeEnv = readEnv(env, 'FIREBASE_ENVIRONMENT').toLowerCase();
  const expectedProject = PROJECT_BY_ENVIRONMENT[runtimeEnv];
  if (!expectedProject) throw invalidConfig();

  const values = Object.fromEntries(
      CONFIG_KEYS.map((key) => [key, readEnv(env, key)]),
  );
  if (Object.values(values).some((value) => !value)) throw invalidConfig();

  if (
    values.FIREBASE_PROJECT_ID !== expectedProject ||
    values.FIREBASE_AUTH_DOMAIN !== `${expectedProject}.firebaseapp.com` ||
    values.FIREBASE_STORAGE_BUCKET !==
      `${expectedProject}.firebasestorage.app`
  ) {
    throw invalidConfig();
  }

  return {
    apiKey: values.FIREBASE_API_KEY,
    authDomain: values.FIREBASE_AUTH_DOMAIN,
    projectId: values.FIREBASE_PROJECT_ID,
    storageBucket: values.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: values.FIREBASE_MESSAGING_SENDER_ID,
    appId: values.FIREBASE_APP_ID,
  };
}
